import get from 'lodash-es/get';

class PageErrorMessage {
  constructor(e) {
    this.name = e.name || 'UnknownError';
    this.message = e.message || '';
    this.stack = e.stack || '';
    this.code = e.code;
  }
}

export const PageErrorMixin = {
  methods: {
    showPageError: function(e, payload) {
      if ('endLoadingPage' in this) {
        this.endLoadingPage();
      }

      const code = get(e, 'response.status', 520);
      this.showPageErrorTemplate(code, {
        error: new PageErrorMessage({ ...e, code: code }),
        payload: payload || {}
      });
    },

    showPageErrorByCode(code, payload = {}) {
      if ('endLoadingPage' in this) {
        this.endLoadingPage();
      }

      const merge_payload = {
        error: new PageErrorMessage({ code: code }),
        payload: payload || {}
      };

      this.showPageErrorTemplate(code, merge_payload);
    },

    showPageErrorTemplate(template, payload = {}) {
      this.$_error(template, payload);
    }
  }
};
